import React from "react";
import { UsersSelect } from "../../forms/AutoCompleteFormItem";

const getItems = (entity, source, scopePrefix) => {
  let items = [];

  const ownerName =
    entity === "leads"
      ? "lead_owner_id"
      : entity === "opportunities"
      ? "oppoprtunity_owner_id"
      : entity === "contacts"
      ? "contact_owner_id"
      : "campaign_owner_id";
  switch (source) {
    case "add_to_campaign":
      items = [
        {
          name: "campaign_id",
          comp: (
            <UsersSelect
              name="campaign_id"
              category={entity}
              // getUser={branch_id !== null}
              extraParams={{
                scopePrefix: scopePrefix,
                filter: {},
              }}
            />
          ),
        },
      ];
      break;

    case "change_owner":
      items = [
        {
          name: ownerName,
          comp: (
            <UsersSelect
              name={ownerName}
              category={entity}
              // getUser={branch_id !== null}
              extraParams={{
                scopePrefix: scopePrefix,
                filter: {},
              }}
            />
          ),
        },
      ];
      break;

    case "change_assigned_user":
      items = [
        {
          name: "assigned_to_id",
          comp: (
            <UsersSelect
              name="assigned_to_id"
              category={entity}
              extraParams={{
                scopePrefix: scopePrefix,
                filter: {},
              }}
            />
          ),
        },
      ];
      break;

    default:
      break;
  }

  return items;
};

export { getItems };
